var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-input',{attrs:{"rows":10,"type":"textarea"},model:{value:(_vm.string),callback:function ($$v) {_vm.string=$$v},expression:"string"}})}
var staticRenderFns = []

export { render, staticRenderFns }